import { render } from "./FactorySchemaNode.vue?vue&type=template&id=985adbd6&scoped=true&ts=true"
import script from "./FactorySchemaNode.vue?vue&type=script&lang=ts"
export * from "./FactorySchemaNode.vue?vue&type=script&lang=ts"

import "./FactorySchemaNode.vue?vue&type=style&index=0&id=985adbd6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985adbd6"]])

export default __exports__